<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-7">
          <div class="card bg-light mb-7">
            <center><h2 class="card-header">Registry Access Request</h2></center>
            <div class="card-body">
              <div class="card-text">
                <p class="lead">
                  <table class="table">
                    <tbody>

                      <div v-if="permissions.currentRole">
                        <tr>
                          <th>You already have {{permissions.currentRole}} access to this Registry</th>
                        </tr>
                      </div>

                      <div v-else>
                        <tr>
                          <th><span class="float-right">Registry:</span></th><th>{{ irr.name }}</th>
                        </tr>
                        <tr>
                          <th><span class="float-right">STATUS:</span></th><th>{{ requestStatus }}</th>
                        </tr>
                        <tr>
                          <th><span class="float-right">SUBMITTED:</span></th><th>{{ accessRequest.created_at.split(" ", 1)[0] }}</th>
                        </tr>
                        <tr>
                          <th><span class="float-right">LAST UPDATED:</span></th><th>{{ accessRequest.updated_at.split(" ", 1)[0] }}</th>
                        </tr>
                        <tr>
                          &nbsp;
                        </tr>
                      </div>

                    </tbody>
                  </table>
                  <a class="btn btn-primary" :href="'/irr/' + irr.id + '/'" role="button">Return to Registry</a>

                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5"></div>

      </div>  <!-- row -->
    </div> <!-- container-fluid -->
  </div>
</template>

<script>
    export default {
    props: {
      route: String,
      permissions: Object,
      irr: Object,
      accessRequest: [Object, Array],
    },
    computed: {
      // a computed getter
      requestStatus: function () {
        return ( (this.accessRequest.pending) ? 'Pending' : ( (this.accessRequest.approved) ? 'Approved' : 'Declined') );
      }
    },
    methods: {
      //
    },
    mounted(){
        //
      },
    }
</script>
